import BaseModel from "./BaseModel";
import User from "./User";

export default class KnowledgebasePost extends BaseModel {

	static entity = 'knowledgebase_posts';
	static route = 'knowledgebase-posts';
	static plural = 'knowledgebase_posts';
	static singular = 'knowledgebase_post';

	static fields () {
		return {
			id: this.attr(null),
			//user_id: this.attr(null),
			knowledgebase_thread_id: this.attr(null),
			post: this.attr(null),
			created_at: this.attr(null),
			updated_at: this.attr(null),
			deleted_at: this.attr(null),
			poster: this.attr(null),
			//user: this.belongsTo(User, 'user_id', 'id'),
			knowledgebase_thread: this.belongsTo(User, 'knowledgebase_thread_id', 'id')
		}
	}

}
